import React from 'react'
import styles from './escalationTag.module.css';

interface EscalationTagProps {
    label: string;
    value: number;
    color: string;
}

export const EscalationTag = (props: EscalationTagProps) => {
    const { label, value, color } = props;
    return (
        <div className={styles.escalationTagCtn}>
            <span className={styles.escalationTagText} style={{ color: color}}>
                {label}: {value}
            </span>
        </div>
    )
}
